import * as React from "react";
import Svg, { Path } from "react-native-svg";

function Info(props) {
  const { height = "16", width = "16", color = "rgba(0, 0, 0, 0.36)" } = props;
  return (
    <Svg
      width={height}
      height={width}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.333252 6.73337C0.333252 3.19865 3.19853 0.333374 6.73325 0.333374C10.268 0.333374 13.1333 3.19865 13.1333 6.73337C13.1333 10.2681 10.268 13.1334 6.73325 13.1334C3.19853 13.1334 0.333252 10.2681 0.333252 6.73337ZM7.37325 4.17337C7.37325 4.00364 7.30582 3.84085 7.1858 3.72083C7.06578 3.6008 6.90299 3.53337 6.73325 3.53337C6.56351 3.53337 6.40073 3.6008 6.2807 3.72083C6.16068 3.84085 6.09325 4.00364 6.09325 4.17337C6.09325 4.34311 6.16068 4.5059 6.2807 4.62592C6.40073 4.74595 6.56351 4.81337 6.73325 4.81337C6.90299 4.81337 7.06578 4.74595 7.1858 4.62592C7.30582 4.5059 7.37325 4.34311 7.37325 4.17337ZM6.73325 9.93337C6.90299 9.93337 7.06578 9.86595 7.1858 9.74592C7.30582 9.6259 7.37325 9.46311 7.37325 9.29337V6.73337C7.37325 6.56364 7.30582 6.40085 7.1858 6.28083C7.06578 6.1608 6.90299 6.09337 6.73325 6.09337C6.56351 6.09337 6.40073 6.1608 6.2807 6.28083C6.16068 6.40085 6.09325 6.56364 6.09325 6.73337V9.29337C6.09325 9.46311 6.16068 9.6259 6.2807 9.74592C6.40073 9.86595 6.56351 9.93337 6.73325 9.93337Z"
        fill={color}
        fill-opacity="0.66"
      />
    </Svg>
  );
}

export default Info;
